import axiosInstance from '../superadminAxiosInstance';
import { BaseService } from './baseService';

class DiscountCodesService extends BaseService<
	DiscountCode,
	'discountCodeID',
	'discountCodes'
> {
	constructor() {
		super('discountCodeID', 'discountCode', 'discountCodes');
	}

	async deleteMultipleDiscountCodes(
		data: DeleteMultipleDiscountCodesRequest[],
	): Promise<void> {
		await axiosInstance.post(
			`/superAdmin/${this.crudResponseArrayName}/batch`,
			data,
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new DiscountCodesService();
